import BaseGeocode from 'lib/location/Locations/Base';
import { parallelGeolocate, LocationSuccessInterface } from 'lib/location/Geolocate';
import { useEffect } from 'react';
import { setGeolocationData } from 'redux-implementations/geolocation';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import State from 'types/State';
import Geocode from 'types/Geocode';

export interface SetLocationInterface {
  (location: Geocode): Promise<void>;
}

export default function useGeoLocation(): {
  geolocation?: Geocode;
  setGeolocation: SetLocationInterface;
} {
  const dispatch = useDispatch();

  useEffect(() => {
    const success: LocationSuccessInterface = (location): void => {
      dispatch(setGeolocationData(location.toJSON()));
    };

    parallelGeolocate(success, console.error);
  }, [dispatch]);

  const setGeolocation: SetLocationInterface = async (location: Geocode): Promise<void> => {
    dispatch(setGeolocationData(location.toJSON()));
  };

  const geolocationData = useSelector((state: State) => state.geolocation, shallowEqual);

  const geolocation = geolocationData ? new BaseGeocode(geolocationData) : undefined;

  return { geolocation, setGeolocation };
}
